import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import CandidateProfileFields from './CandidateProfileSection';
import {recruitmentApi} from '../recruitmentApi';

const CandidateShowComponent = ({t, candidateId}) => {
  const {id} = useParams();
  const [values, setValues] = useState(null);
  const [error, setError] = useState(false);
  const refresh = window.App.state.rerenderCandidateShow;
  useEffect(() => {
    let active = true;
    setValues(null); setError(false);
    recruitmentApi('get', '/candidate/' + (candidateId || id)).then(r => {
      if (active) setValues(r.data.data);
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [id, candidateId, refresh]);
  return <div className="candidate-show widget">
    {error ? <p role="alert" className="p-error">{t('candidateProfile.loadError', {defaultValue: 'A jelölt betöltése nem sikerült. Frissítsd az oldalt.'})}</p>
      : values ? <CandidateProfileFields mode="view" values={values} t={t}/> : <ProgressBar mode="indeterminate" style={{height: 4}}/>}
  </div>;
};
export default withTranslation('common')(CandidateShowComponent);
